<div class="custom-filter-area">
    <div class="filters-area">
        <span class="title-txt">Import File: {{title}}</span>
        <span class="cls-btn" (click)="onCloseBtn()"><mat-icon>close</mat-icon></span>
    </div>
    <div style="display: flex;">
        <div style="display: flex; margin: 5px 10px 0px 0px;">
            <img style="width: 30px;height: 30px;" src="../../../../assets/images/oops.png">
        </div>
        
        <div>
            <!-- <span class="title-txt">{{title}}</span> -->
            <span class="title-txt" style="text-align: center;font-weight: 500;">{{message}}</span>
        </div>
       
    </div>

    <div class="right-area">
        <button class="white-red-btn" (click)="onCloseBtn()">Cancel</button>
        <button class="red-white-btn" (click)="onTryFile()">Try Different File</button>
    </div>

</div>